module.exports = __webpack_public_path__ + "static/img/search.d42a85ff.svg";